import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout'
import strings from '../../components/Language';
import "./profile.scss"
import _ from 'lodash';
import Avatar1 from './../../assets/images/icons/avatar1.svg';
import ArrowForword from './../../assets/images/icons/arrow_forword.svg';
import MemberCenter from './../../assets/images/profile/crown.png';
import Wallet from './../../assets/images/profile/wallet.png';
import ApiBind from './../../assets/images/profile/link.png';
import Team from './../../assets/images/profile/group.png';
import RewardDetails from './../../assets/images/profile/money-bag.png';
import ShareCopy from './../../assets/images/profile/share.png';
import SecurityCenter from './../../assets/images/profile/lock.png';
import Settings from './../../assets/images/profile/setting.png';
import notifications from './../../assets/images/profile/bell.png';
import Copy from './../../assets/images/icons/copy.png';
import AutoTradeIcon from './../../assets/images/icons/autoTradeIconWhite.svg';
import TutorialIcon from './../../assets/images/icons/tutorial.svg';
import ContactUsIcon from './../../assets/images/icons/contact_us.svg';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class ProfileScreen extends React.Component {
	static contextType = LoaderContext;

	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			user_data: {},
			contact_us_url: "https://t.me/ctsbot_info",
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		var self = this;
		setLoading(true);
		axios({
			method: 'GET',
			url: api.profile_show,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage(),
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ user_data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function () {
			setLoading(false);
		});
	};

	copyText(text) {
		navigator.clipboard.writeText(text);
		toast.success(strings.copy_id);
	}

	renderActionItem = (item) => {
		const isActiveAccount = !!(this.state.user_data && this.state.user_data.status);
		const tileContent = (
			<>
				<img src={item.icon} alt={item.label} width={26} height={26} />
				<span>{item.label}</span>
			</>
		);

		if (item.external) {
			return (
				<a key={item.key} href={item.href} target="_blank" rel="noreferrer" className='profile-action-tile'>
					{tileContent}
				</a>
			);
		}

		if (item.requiresActive && !isActiveAccount) {
			return (
				<button
					key={item.key}
					type='button'
					className='profile-action-tile profile-action-btn'
					onClick={() => toast.warning(strings.need_to_active_account)}
				>
					{tileContent}
				</button>
			);
		}

		return (
			<Link key={item.key} to={item.to} className='profile-action-tile'>
				{tileContent}
			</Link>
		);
	}

	render() {
		const userData = this.state.user_data || {};
		const profileActions = [
			[
				{ key: 'api-bind', icon: ApiBind, label: strings.api_bind, to: '/apibind' },
				{ key: 'wallet', icon: Wallet, label: strings.wallet, to: '/wallet' },
				{ key: 'team', icon: Team, label: strings.team, to: '/team' },
				{ key: 'tutorial', icon: TutorialIcon, label: strings.tutorial, to: '/tutorial' },
			],
			[
				{ key: 'autotrade', icon: AutoTradeIcon, label: strings.AutoTrade, to: '/auto-trade' },
				{ key: 'rewards', icon: RewardDetails, label: strings.rewards, to: '/reward' },
				{ key: 'affiliate', icon: MemberCenter, label: strings.affiliate_program, to: '/member-center' },
				{ key: 'share', icon: ShareCopy, label: strings.share, to: '/invite-link', requiresActive: true },
			],
			[
				{ key: 'notification', icon: notifications, label: strings.Notifications, to: '/notifications' },
				{ key: 'security', icon: SecurityCenter, label: strings.security_centre, to: '/security-centre' },
				{ key: 'contact', icon: ContactUsIcon, label: strings.contact_us, href: (this.state.contact_us_url || '/contact-us'), external: true },
				{ key: 'settings', icon: Settings, label: strings.system_setting, to: '/system-setting' },
			],
		];

		return (
			<Layout data={{ "title": strings.Profile }}>
				<div className="profile-page">
					<section className='profile-identity-card'>
						<Link to={'/profile-information'} className='profile-avatar-link'>
							<img
								className='profile-avatar'
								src={(userData && userData.avatar_url) ? userData.avatar_url : Avatar1}
								alt='Profile'
							/>
						</Link>

						<div className='profile-identity-content'>
							<div className='profile-name-row'>
								<Link to={'/profile-information'} className='profile-name'>
									{(userData && userData.name) ? userData.name : '--'}
								</Link>
							</div>

							<div className='profile-id-row'>
								<span>{strings.id}: {(userData && userData.username) ? userData.username : '--'}</span>
								{(userData && userData.username) ?
									<button
										type='button'
										className='profile-copy-btn'
										onClick={() => this.copyText((userData && userData.username) ? userData.username : '')}
									>
										<img src={Copy} alt='Copy' width={12} height={12} />
									</button>
									: null}
							</div>

							<div className='profile-meta-grid'>
								<div className='profile-meta-item'>
									<img src={MemberCenter} alt='Level' width={12} height={12} />
									<span>{strings.Level}: {(userData && userData.level_data && userData.level_data.name) ? userData.level_data.name : '-'}</span>
								</div>
								<div className='profile-meta-item'>
									<span>{strings['Inviter ID']}: {(userData && userData.invitation_code) ? userData.invitation_code : '-'}</span>
								</div>
								<div className='profile-meta-item'>
									<span>{strings.status}: </span>
									<span className={(userData && userData.status_data && userData.status_data.class) ? userData.status_data.class : ''}>
										{(userData && userData.status_data && userData.status_data.name) ? userData.status_data.name : '-'}
									</span>
								</div>
								<div className='profile-meta-item'>
									<span>{strings['Subscription Expire Date']}: {(userData && userData.expired_at_data && userData.expired_at_data.expired_at) ? userData.expired_at_data.expired_at : '-'}</span>
								</div>
							</div>
						</div>

						<Link to={'/profile-information'} className='profile-open-btn'>
							<img src={ArrowForword} alt='Open Profile' />
						</Link>
					</section>

					{profileActions.map((row, rowIndex) => (
						<section key={`row-${rowIndex}`} className='profile-action-grid'>
							{row.map(this.renderActionItem)}
						</section>
					))}
				</div>
			</Layout>
		);
	}
}

export default ProfileScreen;
